<!-- Floating tab — visible when sidecar is closed -->
<!-- <button
  class="gs-sidecar-tab"
  @if (!isOpen) {}
  (click)="open()"
  aria-label="Open ChatTRB assistant">
  <mat-icon class="tab-icon">auto_awesome</mat-icon>
  <span class="tab-label">ChatTRB</span>
</button> -->

<!-- TODO:
	Remove gs-sidecar-btn class
	Remove gs-mode-btn class
	
-->

<!-- Sidecar Panel -->
<div class="gs-sidecar-panel" [class.open]="isOpen" [class.fullscreen]="isFullscreen" role="complementary" aria-label="ChatTRB assistant" data-testid="chat-sidecar-container">
	<!-- Header -->
	<div class="gs-sidecar-header">
		<div class="gs-sidecar-title">
			@if (isFullscreen) {
				<app-button
					class="gs-sidebar-toggle"
					variant="icon"
					category="action"
					iconName="menu"
					[tooltip]="fullscreenSidebarOpen ? 'Hide sidebar' : 'Show sidebar'"
					[onClick]="toggleFullscreenSidebarAction"
				></app-button>
			}
			<mat-icon class="title-icon">auto_awesome</mat-icon>
			<span>ChatTRB</span>
		</div>
		<div class="gs-sidecar-actions">
			@if (messages.length > 0) {
				<app-button class="gs-sidecar-btn" variant="icon" category="action" iconName="sms" tooltip="New chat" [onClick]="startNewChatAction"></app-button>
			}
			<app-button
				class="gs-sidecar-btn"
				variant="icon"
				category="action"
				[iconName]="isFullscreen ? 'close_fullscreen' : 'open_in_full'"
				[tooltip]="isFullscreen ? 'Compact view' : 'Full experience'"
				[onClick]="toggleFullscreenAction"
			></app-button>
			<app-button class="gs-sidecar-btn" variant="icon" category="action" iconName="close" tooltip="Close" [onClick]="closeAction"></app-button>
		</div>
	</div>

	<!-- Body (compact: column layout; fullscreen: row layout) -->
	<div class="gs-body" [class.fullscreen]="isFullscreen" [class.sidebar-collapsed]="isFullscreen && !fullscreenSidebarOpen">
		<!-- Sidebar — always in DOM, shown/hidden via CSS class -->
		<aside class="gs-fullscreen-sidebar" [class.open]="fullscreenSidebarOpen" [class.visible]="isFullscreen">
			<app-conversation-sidebar
				[conversations]="conversations"
				[projects]="projects"
				[activeConversationId]="conversationId"
				[activeProjectId]="selectedProjectId"
				(conversationSelected)="selectConversation($event)"
				(conversationDeleted)="onSidebarConversationDeleted($event)"
				(projectSelected)="selectProject($event)"
				(newChatRequested)="startNewChat()"
				(projectsChanged)="loadHistory(true)"
			>
			</app-conversation-sidebar>
		</aside>

		<!-- Main chat column — single stable instance for all views -->
		<div class="gs-chat-column">
			<!-- Fullscreen nav bar — always in DOM, shown/hidden via CSS class -->
			@if (isFullscreen) {
				<div class="gs-project-nav">
					@if (selectedProjectId && messages.length === 0) {
						<app-button class="gs-project-back" variant="text" iconName="arrow_back" label="All chats" [onClick]="clearProjectAction"></app-button>
					}
					@if (selectedProjectId && messages.length > 0) {
						<app-button class="gs-project-back" variant="text" iconName="arrow_back" [label]="'Back to ' + selectedProjectName" [onClick]="backToProjectAction"></app-button>
					}
				</div>
			}

			<!-- Mode Toggle -->
			<div
				class="gs-sidecar-mode"
				[class.disabled]="modeDisabled"
				[matTooltip]="modeDisabled ? 'Start a new chat to switch modes' : ''"
				matTooltipPosition="above"
				role="group"
				aria-label="Chat mode"
				data-testid="chat-sidecar-panel-mode"
			>
				<app-button
					class="gs-mode-btn"
					[variant]="chatMode === 'rag' ? 'contained' : 'outlined'"
					category="secondary"
					iconName="menu_book"
					label="TRB Library"
					[onClick]="setModeRagAction"
					[fullWidth]="true"
				></app-button>
				@if (hasDirectModePermission) {
					<app-button
						class="gs-mode-btn"
						[variant]="chatMode === 'direct' ? 'contained' : 'outlined'"
						category="secondary"
						iconName="travel_explore"
						label="Ask Anything"
						[onClick]="setModeDirectAction"
						[fullWidth]="true"
					></app-button>
				}
			</div>

			<!-- Project detail: name + conversation list (project overview only) -->
			@if (isInProjectOverview) {
				<div class="gs-project-detail">
					<h1 class="gs-project-name">{{ selectedProjectName }}</h1>
					@for (c of projectConversations; track c.id) {
						<div class="gs-project-conv" (click)="selectConversation(c.id)" (contextmenu)="openConvMenu($event, c)" data-testid="chat-sidecar-item-conversation">
							<span class="gs-project-conv-left">
								@if (c.pinned) {
									<mat-icon class="gs-pin-icon">push_pin</mat-icon>
								}
								<mat-icon class="gs-mode-badge" [class.mode-rag]="c.mode === 'rag'">{{ c.mode === 'rag' ? 'menu_book' : 'travel_explore' }}</mat-icon>
								<span class="gs-project-conv-title">{{ c.title }}</span>
							</span>
							<span class="gs-project-conv-date">{{ c.timestamp | date: 'MMM d' }}</span>
						</div>
					}
					@if (projectConversations.length === 0) {
						<p class="gs-project-empty">No chats yet. Start one above.</p>
					}
				</div>
			}

			<!-- Empty state (not shown when viewing a project overview) -->
			@if (messages.length === 0 && !isLoading && !isInProjectOverview) {
				<div class="gs-sidecar-empty">
					<mat-icon class="empty-icon">auto_awesome</mat-icon>
					<p class="empty-title">How can I help?</p>
					@if (chatMode === 'rag') {
						<p class="empty-hint">Ask about TRB policies, procedures, or documents.</p>
					}
					@if (chatMode === 'direct') {
						<p class="empty-hint">Ask anything — analysis, drafting, general questions.</p>
					}
				</div>
			}

			<!-- Messages -->
			@if (messages.length > 0 || isLoading) {
				<div class="gs-sidecar-messages">
					<app-message-list
						[messages]="messages"
						[isLoading]="isLoading"
						[isSidecar]="!isFullscreen"
						(openArtifact)="onOpenArtifactContent($event)"
						(viewDocument)="onViewDocument($event)"
						(requestFullscreen)="onViewDocument($event)"
					></app-message-list>
				</div>
			}

			<!-- Error -->
			@if (errorMessage) {
				<div class="gs-sidecar-error" (click)="errorMessage = null" data-testid="chat-sidecar-panel-error-dismiss">
					<mat-icon>error_outline</mat-icon>
					<span>{{ errorMessage }}</span>
					<mat-icon class="gs-error-close">close</mat-icon>
				</div>
			}

			<!-- Chat input — always in DOM so app-chat-input lifecycle is stable -->
			<div class="gs-sidecar-input">
				<!-- <div class="gs-sidecar-input" [hidden]="isInProjectOverview"> -->
				<app-chat-input [hideAttach]="chatMode === 'rag'" [disabled]="isLoading" (messageSent)="onSendMessage($event)"></app-chat-input>
			</div>
		</div>

		<!-- Artifact Panel (fullscreen only) -->
		@if (isFullscreen && artifactState.artifactOpen && (artifactState.activeArtifactContent || artifactState.activeDocumentBlob)) {
			<aside class="gs-artifact-zone">
				<app-artifact-panel
					[artifactTitle]="artifactState.activeArtifactTitle"
					[artifactContent]="artifactState.activeArtifactContent"
					[documentBlob]="artifactState.activeDocumentBlob"
					[documentContentType]="artifactState.activeDocumentContentType"
					(closed)="artifactState.closeArtifact()"
				>
				</app-artifact-panel>
			</aside>
		}
	</div>

	<!-- Conversation context menu — must be a direct child of .gs-sidecar-panel so position:fixed
	     resolves against the viewport and is not clipped by .gs-chat-column's overflow:hidden -->
	<app-conversation-context-menu
		[visible]="!!menuConvId"
		[x]="menuX"
		[y]="menuY"
		[projects]="projects"
		[convHasProject]="menuConvHasProject"
		[convProjectId]="menuConvProjectId"
		[convIsPinned]="menuConvPinned"
		(closed)="menuConvId = null"
		(rename)="onMenuRename()"
		(moveToProject)="onMenuMoveToProject($event)"
		(togglePin)="onMenuTogglePin()"
		(deleteConv)="onMenuDelete()"
	></app-conversation-context-menu>

	<!-- Rename dialog -->
	<app-rename-dialog [visible]="!!renameId" title="Rename chat" [(value)]="renameVal" (submitted)="submitRename($event)" (cancelled)="renameId = null; renameVal = ''"></app-rename-dialog>
</div>
